$(function () {
	$('.js-clip-slide').each(function() {
		var controller = new ScrollMagic.Controller();
		var bg = $(this).find('.js-clip-slide__bg');
		var color = $(this).find('.js-clip-slide__color');
		var distance = $(this).data('distance');

		let scene = new ScrollMagic.Scene({
			triggerElement: this,
			triggerHook: distance ? distance : 0.6,
		})
			.addTo(controller);

		scene.on('enter', function () {
			color.addClass('active');
			setTimeout(function () {
				bg.addClass('active');
			},600);
		})
	});

});
